// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedPhacoAddOnWarning_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M23 18.5C23 20.9853 21.2091 23 19 23C16.7909 23 15 20.9853 15 18.5C15 16.0147 16.7909 14 19 14C21.2091 14 23 16.0147 23 18.5Z" fill="#1A2329"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM17.7715 15.3898L19.7297 14.7512V19.6468H17.7715V15.3898ZM17.7715 20.6258H19.7297V22.584H17.7715V20.6258Z" fill="#FDCA40"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0H18V8H13V9H17V11.7127C16.2857 11.8898 15.6131 12.1728 15 12.544V11H9V20.4998C8.58217 20.186 8.0628 20 7.5 20C7.32877 20 7.16155 20.0172 7 20.05V9H11V8H6V0ZM8 2H16V6H8V2Z" class="svg-bg"/>
  <path d="M14 13.2727V12H10V14H13.2727C13.4977 13.7408 13.7408 13.4977 14 13.2727ZM11.8559 21H9.50018C9.81403 21.4178 10 21.9372 10 22.5 10 22.6712 9.98278 22.8384 9.94999 23H12.8756C12.4384 22.3967 12.0918 21.7233 11.8559 21ZM9 22.5C9 23.3284 8.32843 24 7.5 24 6.67157 24 6 23.3284 6 22.5 6 21.6716 6.67157 21 7.5 21 8.32843 21 9 21.6716 9 22.5Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M26.75 32C29.6495 32 32 29.6495 32 26.75C32 23.8505 29.6495 21.5 26.75 21.5C23.8505 21.5 21.5 23.8505 21.5 26.75C21.5 29.6495 23.8505 32 26.75 32ZM25.771 23.3886L27.7292 22.75V27.6456H25.771V23.3886ZM25.771 28.6246H27.7292V30.5828H25.771V28.6246Z" fill="#FDCA40"/>
  <path d="M25.77 23.3886 27.7282 22.75V27.6456H25.77V23.3886ZM25.77 28.6246H27.7282V30.5828H25.77V28.6246Z" fill="#1A2329"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0H24V10H17V12H22V21.2726C21.1237 22.0332 20.4317 23.0007 20 24.0989V14H12V27.7639C11.4692 27.2889 10.7684 27 10 27V12H15V10H8V0ZM10 2H22V8H10V2Z" class="svg-bg"/>
  <path d="M19.8559 29H12.8293C12.9398 29.3128 13 29.6494 13 30 13 30.3506 12.9398 30.6872 12.8293 31H20.8757C20.4384 30.3967 20.0918 29.7233 19.8559 29ZM14 16H18V18H14V16ZM10 32C11.1046 32 12 31.1046 12 30 12 28.8954 11.1046 28 10 28 8.89543 28 8 28.8954 8 30 8 31.1046 8.89543 32 10 32Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedPhacoAddOnWarning is a generated icon component.
 */
let IconMedPhacoAddOnWarning = IconMedPhacoAddOnWarning_1 = class IconMedPhacoAddOnWarning extends IconBaseElement {
    render() {
        return html `${IconMedPhacoAddOnWarning_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedPhacoAddOnWarning.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedPhacoAddOnWarning = IconMedPhacoAddOnWarning_1 = __decorate([
    customElement('zui-icon-med-phaco-add-on-warning')
], IconMedPhacoAddOnWarning);
export { IconMedPhacoAddOnWarning };
